export const commandType = "SCHEDULE_FLY_TO_Z";
export const label = "Fly to z";
export const isAdminOnly = true;
export const isAdvanced = true;
export const organizations = [];
